<!-- 找回密码 -->
<template>
<div class="login-wrap">
  <div class="container main-1">
    <h2>忘记密码 <span>想起密码了？<nuxt-link to="/login" class="yf-login-text">返回登录</nuxt-link></span></h2>

    <y-status-bar class="login-status-bar" :type="type" />

    <section class="form">
      <template v-if="type === 1">
        <div class="form-item clearfix">
          <label for="username" class="left large">用户名：</label>
          <input
            class="login-input left"
            :class="{ success: userName__state === 'success', error: userName__state === 'error' }"
            type="text"
            v-model.trim="userName"
            autofocus
            tabindex="1"
            @focus="userName__state = 'normal'"
            @blur="checkUserName">
          <div class="login-tip left">
            <p class="placeholder" v-if="userName__state === 'normal'">请输入您的昵称</p>
            <p class="error yf-text_red" v-else-if="userName__state === 'error'">
              <i class="iconfont icon-cuowu"></i> {{ userName__state_Msg }}
            </p>
            <p class="success" v-else-if="userName__state === 'success'">
              <i class="iconfont icon-zq"></i>
            </p>
          </div>
        </div>
        <div class="form-item clearfix">
          <label for="phoneNumber" class="left large">手机号：</label>
          <input
            class="login-input left"
            :class="{ success: phoneNumber__state === 'success', error: phoneNumber__state === 'error' }"
            type="text"
            v-model="phoneNumber"
            autofocus
            tabindex="2"
            @focus="phoneNumber__state = 'normal'"
            @blur="checkPhoneNumber">
          <div class="login-tip left">
            <p class="placeholder" v-if="phoneNumber__state === 'normal'">请输入手机号来获取验证码（如之前未绑定手机可通过下方提示联系客服）</p>
            <p class="error yf-text_red" v-else-if="phoneNumber__state === 'error'">
              <i class="iconfont icon-cuowu"></i> {{ phoneNumber__state_Msg }}
            </p>
            <p class="success" v-else-if="phoneNumber__state === 'success'">
              <i class="iconfont icon-zq"></i>
            </p>
          </div>
        </div>
        <div class="form-item clearfix">
          <label for="vercode" class="left large">验证码：</label>
          <input
            class="login-input left"
            :class="{ success: verCode__state === 'success', error: verCode__state === 'error' }"
            type="text"
            style="width: 200px;"
            v-model="verCode"
            tabindex="4"
            maxlength="6"
            @focus="verCode__state = 'normal'"
            @blur="checkVerCode">
          <button type="button" class="left msg-code" tabindex="6" v-if="!verCode1.length" @click="getVerCode">获取验证码</button>
          <button type="button" class="left verify-code" tabindex="6" v-else @click="getVerCode">{{ verCode1 }}</button>
          <div class="login-tip left">
            <p class="placeholder" v-if="verCode__state === 'normal'">点击可获取验证码</p>
            <p class="error yf-text_red" v-else-if="verCode__state === 'error'">
              <i class="iconfont icon-cuowu"></i> {{ verCode__state_Msg }}
            </p>
          </div>
        </div>
        <div class="form-item clearfix">
          <label for="msgCode" class="left large">短信验证码：</label>
          <input
            class="login-input left"
            :class="{ success: msgCode__state === 'success', error: msgCode__state === 'error' }"
            type="password"
            style="width: 200px;"
            v-model="msgCode"
            tabindex="3"
            maxlength="16"
            @focus="msgCode__state = 'normal'"
            @blur="checkMsgCode">
          <button type="button" class="left msg-code" :class="{ 'send-auth-code': isSendAuthCode }" tabindex="5" @click="getAuthCode">{{ isSendAuthCode ? `${time}s后重新获取` : '获取手机验证码' }}</button>
          <div class="login-tip left">
            <p class="error yf-text_red" v-if="msgCode__state === 'error'">
              <i class="iconfont icon-cuowu"></i> {{ msgCode__state_Msg }}
            </p>
            <p class="success" v-else-if="msgCode__state === 'success'">
              <i class="iconfont icon-zq"></i>
            </p>
          </div>
        </div>
      </template>
      <template v-else-if="type === 2">
        <div class="form-item clearfix">
          <label for="passWord" class="left large">密码：</label>
          <input
            class="login-input left"
            :class="{ success: passWord__state === 'success', error: passWord__state === 'error' }"
            type="passWord"
            v-model="passWord"
            tabindex="2"
            maxlength="16"
            @blur="checkpassWord"
            @focus="passWord__state = 'normal'">
          <div class="login-tip left">
            <p class="placeholder" v-if="passWord__state === 'normal'">6-16位，英文（区分大小写）、数字或常用符号</p>
            <p class="error yf-text_red" v-else-if="passWord__state === 'error'">
              <i class="iconfont icon-cuowu"></i> {{ passWord__state_Msg }}
            </p>
            <p class="success" v-else-if="passWord__state === 'success'">
              <i class="iconfont icon-zq"></i>
            </p>
          </div>
        </div>
        <div class="form-item clearfix">
        <label for="passWord" class="left large">确认新密码：</label>
          <input
            class="login-input left"
            :class="{ success: passWord1__state === 'success', error: passWord1__state === 'error' }"
            type="passWord"
            v-model="passWord1"
            tabindex="2"
            maxlength="16"
            @blur="checkpassWord1"
            @focus="passWord1__state = 'normal'">
          <div class="login-tip left">
            <p class="error yf-text_red" v-if="passWord1__state === 'error'">
              <i class="iconfont icon-cuowu"></i> {{ passWord1__state_Msg }}
            </p>
            <p class="success" v-else-if="passWord1__state === 'success'">
              <i class="iconfont icon-zq"></i>
            </p>
          </div>
        </div>
      </template>
      <template v-else-if="type === 3">
        <div class="change-pw-success">
          <p>新登录密码已设置成功，请牢记新密码！</p>
          <p><nuxt-link to="/login">去登录</nuxt-link></p>
        </div>
      </template>
      <div v-if="type !== 3" class="form-item form-item-1 large">
        <button type="button" class="login-btn" tabindex="3" @click="changePassword">下一步</button>
      </div>
    </section>
    <div v-if="type !== 3" class="register-tip" style="text-align: center; font-size: 14px; margin-top: 50px; color: #999;">
      若您之前未绑定过手机，请联系客服进行验证，需提供相关注册信息，客服QQ群：<span class="yf-text_red">850536068</span>，客服电话：<span class="yf-text_red">18057806199</span>
    </div>
  </div>
</div>
</template>

<script>
import Dialog from '~/utils/Dialog'
import YStatusBar from '~/components/user/StatusBar'
import md5 from '~/utils/md5'

export default {
  name: 'forgot-password',
  scrollToTop: true,
  head () {
    return {
      title: '修改密码-一富财经'
    }
  },
  data () {
    return {
      type: 1,

      userName: '',
      userName__state: 'normal',
      userName__state_Msg: '',

      phoneNumber: '',
      phoneNumber__state: 'normal',
      phoneNumber__state_Msg: '',

      verCode: '',
      verCode1: '',
      verCode__state: 'normal',
      verCode__state_Msg: '',

      msgCode: '',
      msgCode__state: 'normal',
      msgCode__state_Msg: '',
      isSendAuthCode: false,
      time: 59,

      passWord: '',
      passWord__state: 'normal',
      passWord__state_Msg: '',

      passWord1: '',
      passWord1__state: 'normal',
      passWord1__state_Msg: '',
    }
  },
  methods: {
    getVerCode () {
      this.$axios._get('/Common/VerificationCode').then(res => {
        this.verCode1 = res
      })
    },
    checkVerCode () {
      if (!this.verCode1.length) {
        this.verCode__state = 'error'
        this.verCode__state_Msg = '请获取验证码！'
        return false
      } else if (!this.verCode.length) {
        this.verCode__state = 'error'
        this.verCode__state_Msg = '请输入验证码！'
        return false
      } else {
        this.verCode__state = 'normal'
        this.verCode__state_Msg = ''
        return true
      }
    },
    checkUserName () {
      if (this.userName === '') {
        this.userName__state = 'error'
        this.userName__state_Msg = '用户名不能为空！'
        return false
      } else {
        this.userName__state = 'success'
        return true
      }
    },
    checkPhoneNumber () {
      let isNull = Boolean(this.phoneNumber === '')
      let isPhoneNumber = /^1[3456789]\d{9}$/.test(this.phoneNumber)
      if (isNull || !isPhoneNumber) {
        this.phoneNumber__state = 'error'
        if (isNull) {
          this.phoneNumber__state_Msg = '请输入手机号！'
        } else if (!isPhoneNumber) {
          this.phoneNumber__state_Msg = '手机号格式不正确！'
        }
        return false
      } else {
        return this.$axios._get('/Auth/Verify', { type: 'phone', value: this.phoneNumber }).then(res => {
          if (res.used === '1') {
            this.phoneNumber__state = 'success'
            return true
          } else {
            this.phoneNumber__state = 'error'
            this.phoneNumber__state_Msg = '手机号未被注册'
            return false
          }
        })
      }
    },
    checkMsgCode () {
      if (this.msgCode === '') {
        this.msgCode__state = 'error'
        this.msgCode__state_Msg = '请输入短信验证码'
        return false
      } else {
        this.msgCode__state = 'success'
        return true
      }
    },
    getAuthCode (e) {
      if (this.checkVerCode()) {
        let isCan = this.checkPhoneNumber()
  
        if (typeof isCan.then === 'function') {
          isCan.then(res => {
            if (res) {
              // e.target.disabled = true
              this.$axios._post('/Common/SmsCode', {
                phone: this.phoneNumber,
                verCode: md5('sgvm-' + this.verCode).toUpperCase()
              }).then(() => {
                this.isSendAuthCode = true
                var t = setInterval(() => {
                  this.time -= 1
                  if (this.time === 0) {
                    clearInterval(t)
                    this.isSendAuthCode = false
                  }
                }, 1000)
              }).catch((err) => {
                // e.target.disabled = false
                console.log(err)
              })
            }
          })
        }
      }
    },
    checkpassWord () {
      let isNull = Boolean(this.passWord === '')
      let l = this.passWord.length
      if (isNull || l < 6) {
        this.passWord__state = 'error'
        if (isNull) {
          this.passWord__state_Msg = '请输入密码！'
        } else if (l < 6) {
          this.passWord__state_Msg = '密码长度至少六位数'
        }
        return false
      } else {
        this.passWord__state = 'success'
        return true
      }
    },
    checkpassWord1 () {
      let isNull = Boolean(this.passWord1 === '')
      let notEqual = Boolean(this.passWord1 !== this.passWord)
      if (isNull || notEqual) {
        this.passWord1__state = 'error'
        if (isNull) {
          this.passWord1__state_Msg = '请再次输入密码！'
        }
        if (notEqual) {
          this.passWord1__state_Msg = '两次密码输入不一致！'
        }
        return false
      } else {
        this.passWord1__state = 'success'
        return true
      }
    },
    changePassword (e) {
      if (this.type === 1) {
        if (this.checkUserName() && this.checkPhoneNumber() && this.checkMsgCode()) {
          this.type = 2
        }
      } else if (this.type === 2) {
        if (this.checkpassWord() && this.checkpassWord1()) {
          e.target.disabled = true
          this.$axios._post('/Auth/ForgetPassword', {
            phone: this.phoneNumber,
            password: this.passWord1,
            code: this.msgCode
          }).then(() => {
            this.type = 3
          }).catch(() => {
            Dialog.alert('设置新密码失败，请刷新页面重新设置！')
          }).finally(() => {
            e.target.disabled = false
          })
        }
      }
    }
  },
  components: {
    YStatusBar
  }
}
</script>
